if (!customElements.get('google-reviews')) {
  customElements.define('google-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-reviews-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-reviews-prev]');
      this.next = this.querySelector('[data-reviews-next]');
      this.designMode = window.Shopify && window.Shopify.designMode;
      this.clones = [];

      this.setupLoop();

      this.prev && this.prev.addEventListener('click', () => { this.goPrev(); this.restart(); });
      this.next && this.next.addEventListener('click', () => { this.goNext(); this.restart(); });
      this.resizeHandler = () => this.setupLoop();
      window.addEventListener('resize', this.resizeHandler);

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.visibilityHandler = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.visibilityHandler);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener('resize', this.resizeHandler);
      document.removeEventListener('visibilitychange', this.visibilityHandler);
    }

    setupLoop() {
      this.clones.forEach((clone) => clone.remove());
      this.clones = [];
      this.loopWidth = 0;
      this.canLoop = false;

      const cards = Array.from(this.track.querySelectorAll('[data-reviews-card]'));
      if (cards.length === 0) return;

      const overflowing = this.track.scrollWidth > this.track.clientWidth + 1;
      if (!overflowing || this.designMode) return;

      cards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        Array.from(clone.attributes).forEach((attr) => {
          if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
        });
        clone.classList.add('gr__card--clone');
        this.track.appendChild(clone);
        this.clones.push(clone);
      });

      this.loopWidth = this.clones[0].offsetLeft;
      this.canLoop = this.loopWidth > 0;
    }

    step() {
      const card = this.track.querySelector('[data-reviews-card]');
      if (!card) return this.track.clientWidth;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.offsetWidth + gap;
    }

    goNext() {
      if (this.canLoop && this.track.scrollLeft >= this.loopWidth - 1) {
        this.track.scrollLeft -= this.loopWidth;
      }
      this.track.scrollBy({ left: this.step(), behavior: 'smooth' });
    }

    goPrev() {
      if (this.canLoop && this.track.scrollLeft <= 0) {
        this.track.scrollLeft += this.loopWidth;
      }
      this.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
    }

    start() {
      if (this.timer || this.dataset.autorotate !== 'true' || !this.canLoop) return;
      const seconds = parseFloat(this.dataset.autorotateSpeed) || 5;
      this.timer = setInterval(() => this.goNext(), seconds * 1000);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  });
}
